import React from 'react';

import CustomHead from '@components/CustomHead';
import Footer from '@components/FooterNew';
import Header from '@components/HeaderNew';
import Heading from '@components/Heading';
import HeroBottom from '@components/HeroBottom';
import Section from '@components/Section';
import TutorialsGrid from '@components/tutorials/TutorialGrid';

const LearnSqlPage = ({ tutorials }) => {
  return (
    <>
      <CustomHead
        meta={{
          title: 'Learn SQL | PopSQL',
          image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/images/og/learn.jpg`,
        }}
        openGraph={{
          title: 'Learn SQL | PopSQL',
          image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/images/og/learn.jpg`,
        }}
      />
      <main>
        <Header />
        <Section
          customStyles={{
            background: `url(${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/home_hero_bg.svg)`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top',
          }}
        >
          <Heading Tag="h1" className="lg:text-[64px] mt-2 sm:mt-10">
            Learn SQL
          </Heading>
          <TutorialsGrid
            desc="Learn to answer data questions with each SQL flavour available."
            tutorials={tutorials}
          />
          <HeroBottom
            icon={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/popsql_app_icon.png`}
            title="The most powerful workspace for data teams"
            description=""
          />
        </Section>
      </main>
      <Footer />
    </>
  );
};

export async function getStaticProps() {
  try {
    const tutorials = [
      'PostgreSQL',
      'MySQL',
      'Redshift',
      'SQL Server',
      'BigQuery',
      'Snowflake',
      'dbt',
    ];

    return {
      props: {
        tutorials,
      },
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        err: 'Something went wrong 😕',
      },
    };
  }
}

export default LearnSqlPage;
